import React from "react";
import Helmet from "react-helmet";
import Main from "../../components/main";
import Box from "../../components/box";
import A from "../../components/a";
import H1 from "../../components/h1";
import P from "../../components/p";
import Img from "../../components/img";
import login from "../instructions/assets/login.png";
import google from "../instructions/assets/google.png";
import key from "../instructions/assets/key.png";
import main from "../instructions/assets/main.png";
import running from "../instructions/assets/running.png";
import success from "../instructions/assets/success.png";
import "./styles.css";

const Images = () => (
  <Main>
    <Helmet>
      <title>Ghast.io: Product Images</title>
      <meta
        name="description"
        content="Ghast Lag fix is the BEST Software for Improving Your Minecraft Connection, Shown to provide a BRUTAL combination of ..."
      />
    </Helmet>
    <Box>
      <H1>Product Images</H1>
      <P>
        We have uploaded these images to help you get a better overview of our
        product. If you would like further explanation, you can also check out
        the{" "}
        <A className="redlink" href="/instructions">
          Instructions
        </A>{" "}
        page!
      </P>
      <div className="images">
        <Img src={login} />
        <Img src={google} />
        <Img src={key} />
        <Img src={main} />
        <Img src={running} />
        <Img src={success} />
      </div>
    </Box>
  </Main>
);

export default Images;



/** WEBPACK FOOTER **
 ** ./src/views/pages/images/index.js
 **/